import { render, staticRenderFns } from "./DadosClimaticos.vue?vue&type=template&id=4d4264af&scoped=true"
import script from "./DadosClimaticos.vue?vue&type=script&lang=js"
export * from "./DadosClimaticos.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=4d4264af&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4264af",
  null
  
)

export default component.exports